/* Motion design TIPSY. — voir snippets/tipsy-motion.liquid */
  (() => {
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (calm.matches) return;

    /* 2. Cartes produit sur écran tactile. */
    const touch = window.matchMedia('(hover: none)');
    let cardObserver = null;
    const watchCards = (root) => {
      if (!touch.matches || !('IntersectionObserver' in window)) return;
      if (!cardObserver) {
        cardObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const card = entry.target;
              clearTimeout(card.tpmTimer);
              clearInterval(card.tpmLoop);
              if (entry.isIntersecting) {
                const delay = 900 + (Number(card.dataset.tpmIndex) % 4) * 450;
                card.tpmTimer = setTimeout(() => {
                  card.classList.add('is-worn');
                  card.tpmLoop = setInterval(() => card.classList.toggle('is-worn'), 3200);
                }, delay);
              } else {
                card.classList.remove('is-worn');
              }
            });
          },
          { threshold: 0.6 }
        );
      }
      root.querySelectorAll('.tpk').forEach((card, i) => {
        if (card.dataset.tpmIndex || !card.querySelector('.tpk__img--worn')) return;
        card.dataset.tpmIndex = String(i);
        cardObserver.observe(card);
      });
    };

    /* 3. Bandeau « Vus de dos » : on double la rangée pour une boucle sans couture. */
    const marquee = (root) => {
      root.querySelectorAll('[id$="__worn_back"] .tlb, [id$="__lookbook"] .tlb').forEach((section) => {
        if (section.classList.contains('tpm-marquee') || section.classList.contains('tlb--carousel')) return;
        const grid = section.querySelector('.tlb__grid');
        if (!grid || grid.children.length < 3) return;
        Array.from(grid.children).forEach((cell) => {
          const copy = cell.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.setAttribute('tabindex', '-1');
          copy.querySelectorAll('a, [href]').forEach((el) => el.setAttribute('tabindex', '-1'));
          grid.append(copy);
        });
        section.style.setProperty('--tpm-speed', Math.max(30, grid.children.length / 2 * 18) + 's');
        section.classList.add('tpm-marquee');
      });
    };

    /* 4. Rebond du compteur de panier à chaque changement. */
    const watchCart = () => {
      document.querySelectorAll('.header-actions__cart-icon').forEach((icon) => {
        if (icon.dataset.tpmCart) return;
        icon.dataset.tpmCart = '1';
        let last = icon.textContent.replace(/\D/g, '');
        new MutationObserver(() => {
          const now = icon.textContent.replace(/\D/g, '');
          if (now === last) return;
          last = now;
          const target = icon.querySelector('.cart-bubble') || icon;
          target.classList.remove('tpm-bump');
          void target.offsetWidth;
          target.classList.add('tpm-bump');
        }).observe(icon, { subtree: true, childList: true, characterData: true });
      });
    };

    /* 5. Vidéo de bannière : lecture garantie (l'autoplay peut rester en
       suspens si la page s'ouvre en arrière-plan), pause hors écran. */
    const heroVideos = (root) => {
      root.querySelectorAll('.tph__video').forEach((video) => {
        if (video.dataset.tpmVideo) return;
        video.dataset.tpmVideo = '1';
        video.muted = true;
        let onScreen = true;
        const tryPlay = () => {
          if (onScreen && !document.hidden && video.paused) {
            const p = video.play();
            if (p && p.catch) p.catch(() => {});
          }
        };
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => {
            onScreen = entries[0].isIntersecting;
            if (onScreen) tryPlay(); else video.pause();
          }, { threshold: 0.05 }).observe(video);
        }
        document.addEventListener('visibilitychange', tryPlay);
        video.addEventListener('canplay', tryPlay, { once: true });
        tryPlay();
      });
    };

    const init = (root = document) => {
      watchCards(root);
      marquee(root);
      if (window.tpmPauseInit) window.tpmPauseInit();
      watchCart();
      heroVideos(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

/* Pause des bandes défilantes (WCAG 2.2.2) : tourne même sous reduced-motion. */
(() => {
  const PLAY = '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M2 1l7 4-7 4z"/></svg>';
  const PAUSE = '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M2 1h2v8H2zM6 1h2v8H6z"/></svg>';
  const makeButton = (host, onToggle, className) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.innerHTML = PAUSE;
    button.setAttribute('aria-label', 'Pause the scrolling list');
    button.addEventListener('click', () => {
      const paused = onToggle();
      button.innerHTML = paused ? PLAY : PAUSE;
      button.setAttribute('aria-label', paused ? 'Resume the scrolling list' : 'Pause the scrolling list');
    });
    host.append(button);
  };
  const init = () => {
    document.querySelectorAll('marquee-component').forEach((marquee) => {
      if (marquee.querySelector('.marquee-pause')) return;
      if (getComputedStyle(marquee).position === 'static') marquee.style.position = 'relative';
      makeButton(marquee, () => marquee.toggleAttribute('data-paused'), 'marquee-pause');
    });
    document.querySelectorAll('.tpm-marquee').forEach((section) => {
      const band = section.querySelector('.tlb__band');
      if (!band || band.querySelector('.tpm-pause')) return;
      makeButton(band, () => section.classList.toggle('tpm-paused'), 'tpm-pause');
    });
  };
  window.tpmPauseInit = init;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* Logo qui s'écrit : le logo IMAGE d'origine (pixels exacts) est révélé selon le
   geste d'écriture (barre du T, jambage, « ip », « sy », point du i, point final),
   plume levée entre deux tracés. Squelette (s, coordonnées du PNG 2000 x 1070) et
   vitesse de plume (T : instant 0-10000 où la plume atteint chaque palier de q
   unités ; ralentie dans les boucles et retournements, lancée dans les longues
   courbes) sont précalculés depuis le PNG. Au chargement, une carte des instants
   de passage est calculée : chaque pixel du logo appartient au tracé le plus
   proche, il n'apparaît donc que quand la plume passe sur SON trait (pas de
   pastille aux croisements ni de bout rond en attente). Le logo est recopié dans
   un canvas où chaque pixel monte en opacité juste derrière la plume (pointe
   légèrement fondue dans le sens du geste). Sert à
   l'en-tête (1re page de la visite, classe tpm-intro) et à tout logo marqué
   data-tpm-write (bannière d'accueil). */
(() => {
  const root = document.documentElement;
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const D = {"w":46,"dot":[1940,644,34],"q":16,"s":[[42,234,78,216,123,200,154,191,231,170,289,157,439,128,561,109,736,87,919,72,1011,69,1079,70,1143,74,1170,79,1188,84],[745,42,670,125,615,189,512,316,417,440,330,560,258,665,208,747,179,804,174,819,172,833],[627,461,617,467,608,474,577,506,549,540,529,570,519,591,516,607,518,622,522,628,527,633,534,636,541,638,561,637,584,632,614,621,664,596,700,577,805,512,820,507,834,506,862,479,886,449,866,474,844,497,837,506,821,538,747,647,742,658,736,676,731,687,704,722,665,777,593,888,558,946,549,959,541,967],[742,678,756,672,766,665,845,580,901,529,929,507,963,485,990,469,1012,460,1035,453,1047,451,1054,452,1064,457,1068,463,1071,470,1071,481,1066,496,1058,510,1042,533,1031,553,1019,563,981,584,975,586,953,588,941,591,923,598,901,609,888,619,880,627,876,636,877,642,879,644,884,647,895,646,910,640,928,631,958,611,975,591,981,586,1022,562,1032,559,1055,556,1070,552,1119,534,1174,511,1189,508,1201,508,1246,469,1277,450,1299,440,1325,431,1352,425,1372,424,1390,429],[1201,508,1199,524,1200,540,1202,551,1206,562,1215,575,1243,603,1255,618,1242,628,1215,645,1189,663,1174,676,1154,695,1146,704,1141,715,1140,726,1144,735,1150,739,1161,741,1172,741,1184,738,1199,732,1213,725,1238,706,1257,685,1268,668,1271,657,1273,650,1271,620,1276,611,1285,604,1317,588,1433,533,1506,501,1543,492,1568,475,1549,490,1541,498,1526,525,1498,564,1484,588,1478,603,1477,615,1479,625,1485,633,1496,636,1511,634,1530,627,1551,616,1588,592,1620,568,1706,497,1720,489,1738,484,1737,508,1733,531,1699,638,1676,674,1662,711,1629,770,1598,822,1561,874,1523,920,1502,944,1461,982,1428,1006,1405,1020,1382,1028,1370,1029,1359,1028,1352,1025,1346,1021,1341,1015,1338,1008,1336,1001,1335,989,1337,969,1344,951,1359,922,1377,896,1397,871,1424,841,1494,776,1572,720,1613,695,1641,680,1659,675,1673,676,1686,661,1693,648,1700,640,1701,639,1716,640,1727,637,1781,611,1865,574,1917,553,1928,550,1941,548],[654,393,661,390,707,355]],"T":[[0,15,30,43,56,69,80,92,104,116,127,139,151,162,174,186,198,209,221,233,245,256,268,280,292,303,315,327,338,350,362,374,385,397,409,421,432,444,456,468,479,491,503,514,526,538,550,561,573,585,597,608,620,632,644,655,667,679,690,702,714,726,737,749,761,773,784,796,808,820,835,850,868,886],[1197,1213,1227,1241,1254,1266,1278,1289,1301,1313,1325,1336,1348,1360,1372,1383,1395,1407,1419,1430,1442,1454,1465,1477,1489,1501,1512,1524,1536,1548,1559,1571,1583,1595,1606,1618,1630,1641,1653,1665,1677,1688,1700,1712,1724,1735,1747,1759,1771,1782,1794,1806,1817,1829,1841,1853,1864,1876,1890,1907,1928,1952,1961],[2289,2309,2326,2342,2355,2368,2379,2391,2404,2419,2436,2458,2486,2519,2551,2579,2601,2620,2635,2648,2660,2672,2684,2696,2707,2719,2731,2742,2754,2766,2778,2790,2804,2821,2840,2862,2883,2904,2928,2954,2987,3013,3035,3053,3069,3084,3098,3111,3123,3135,3147,3159,3170,3183,3196,3210,3226,3242,3258,3272,3285,3297,3308,3320,3332,3344,3355,3367,3379,3391,3402,3414,3426,3438,3449,3462,3477,3494,3516,3535],[3836,3860,3880,3897,3912,3925,3937,3948,3960,3972,3984,3995,4007,4019,4031,4042,4054,4066,4078,4090,4102,4116,4132,4151,4175,4206,4241,4273,4298,4317,4334,4351,4368,4387,4407,4426,4444,4463,4482,4500,4518,4538,4562,4593,4628,4661,4687,4708,4725,4742,4759,4777,4795,4812,4829,4846,4864,4879,4893,4906,4918,4930,4942,4954,4968,4985,5004,5024,5042,5057,5070,5083,5096,5110,5123,5137,5153,5172,5195,5220,5242],[5527,5549,5573,5598,5621,5643,5664,5688,5716,5743,5764,5780,5793,5805,5817,5832,5849,5872,5903,5938,5972,6001,6025,6045,6064,6081,6098,6117,6137,6160,6186,6214,6242,6266,6284,6299,6311,6323,6335,6347,6358,6370,6382,6394,6405,6417,6429,6441,6454,6470,6489,6514,6545,6581,6611,6634,6652,6666,6678,6691,6704,6721,6742,6770,6804,6838,6866,6888,6905,6919,6931,6943,6955,6967,6978,6990,7002,7014,7025,7038,7052,7069,7092,7124,7155,7179,7197,7211,7223,7235,7247,7259,7272,7286,7301,7316,7331,7345,7358,7371,7383,7395,7407,7418,7430,7442,7454,7465,7477,7489,7500,7512,7524,7536,7547,7559,7571,7583,7594,7606,7618,7630,7643,7657,7675,7696,7722,7753,7784,7815,7842,7864,7883,7899,7913,7926,7938,7950,7962,7973,7985,7997,8008,8020,8032,8044,8055,8067,8079,8091,8102,8114,8126,8138,8149,8161,8174,8189,8207,8230,8257,8287,8317,8346,8369,8387,8402,8415,8427,8439,8450,8462,8474,8486,8497,8510,8524,8541,8561,8581],[8987,9016,9044,9070,9097,9100]]};
  const DOT0 = D.T[D.T.length - 1][D.T[D.T.length - 1].length - 1] + 400;
  /* Temps « plume posée » écoulé à l'instant u, levers de plume exclus (0-1). */
  /* Les levers de plume comptent à 40 % : assez pour que l'encre fraîche du
     tracé précédent finisse de se poser, sans gaspiller la précision de la carte. */
  const spans = [];
  D.T.forEach((T, i) => {
    spans.push([T[0], T[T.length - 1], 1]);
    spans.push([T[T.length - 1], i < D.T.length - 1 ? D.T[i + 1][0] : DOT0, 0.4]);
  });
  spans.push([DOT0, 10000, 1]);
  const ACTIVE = spans.reduce((a, s) => a + (s[1] - s[0]) * s[2], 0);
  const ink = (u) => spans.reduce((a, s) => a + Math.min(Math.max(u - s[0], 0), s[1] - s[0]) * s[2], 0) / ACTIVE;
  let map = null;
  /* Carte des instants de passage (500 x 268, 1 pixel = 4 unités du PNG),
     calculée une fois par page. */
  const tick = () => new Promise((ok) => setTimeout(ok, 0));
  const timeMap = () => {
    if (!map) map = buildMap();
    return map;
  };
  /* Calcul découpé en quelques tâches courtes pour ne pas bloquer la page. */
  const buildMap = async () => {
    const S = 4;
    const ONSET = 50;
    const w = 500;
    const h = 268;
    const R = D.w / 2 + 8;
    const xs = [], ys = [], ts = [];
    D.s.forEach((pts, i) => {
      const T = D.T[i];
      let run = 0;
      let len = 0;
      for (let j = 2; j < pts.length; j += 2) len += Math.hypot(pts[j] - pts[j - 2], pts[j + 1] - pts[j - 1]);
      for (let j = 2; j < pts.length; j += 2) {
        const x0 = pts[j - 2], y0 = pts[j - 1];
        const seg = Math.hypot(pts[j] - x0, pts[j + 1] - y0);
        for (let a = 0; a < seg; a += 3.5) {
          /* Attaque : les premières unités d'un tracé se posent ensemble (un
             petit trait, jamais un point isolé). */
          const p = Math.max(run + a, Math.min(ONSET, len * 0.6)) / D.q;
          const k = Math.min(T.length - 2, Math.floor(p));
          const X = x0 + (pts[j] - x0) * a / seg, Y = y0 + (pts[j + 1] - y0) * a / seg;
          xs.push(X);
          ys.push(Y);
          ts.push(len < 120 ? -1 - i : ink(T[k] + (T[k + 1] - T[k]) * Math.min(1, p - k)));
        }
        run += seg;
      }
    });
    const time = new Float32Array(w * h).fill(2);
    const r = Math.ceil(R / S);
    const RR = (R / S) * (R / S);
    const n = xs.length;
    const box = new Int16Array(n * 4);
    for (let k = 0; k < n; k++) {
      const cx = xs[k] / S - 0.5, cy = ys[k] / S - 0.5;
      box[k * 4] = Math.max(0, Math.ceil(cx - r));
      box[k * 4 + 1] = Math.min(w - 1, Math.floor(cx + r));
      box[k * 4 + 2] = Math.max(0, Math.ceil(cy - r));
      box[k * 4 + 3] = Math.min(h - 1, Math.floor(cy + r));
    }
    /* Instant de passage d'un pixel : le premier passage de plume qui le couvre
       (à moins de HALF unités du tracé, l'épaisseur d'encre) ; au-delà (bords,
       congés des jonctions), l'encre s'étend un peu après le passage le plus
       proche (KAPPA par unité). Champ continu : ni trou, ni entaille, ni dent aux
       croisements et jonctions. */
    const HALF = 14, KAPPA = 0.03;
    for (let k = 0; k < n; k++) {
      if (k % 1500 === 0) await tick();
      const cx = xs[k] / S - 0.5, cy = ys[k] / S - 0.5, t = ts[k];
      for (let y = box[k * 4 + 2]; y <= box[k * 4 + 3]; y++) {
        const dy = (y - cy) * (y - cy);
        for (let x = box[k * 4]; x <= box[k * 4 + 1]; x++) {
          const q = (x - cx) * (x - cx) + dy;
          if (q >= RR) continue;
          const o = y * w + x;
          const v = t < 0 ? t : t + KAPPA * Math.max(0, Math.sqrt(q) * S - HALF);
          if (v < time[o]) time[o] = v;
        }
      }
    }
    /* Point du i : il s'étale depuis son centre (ellipse orientée selon le trait),
       comme le point final, au lieu d'apparaître en fondu. */
    D.s.forEach((pts, i) => {
      const T = D.T[i];
      const n = pts.length;
      const ax = pts[n - 2] - pts[0], ay = pts[n - 1] - pts[1];
      const half = Math.hypot(ax, ay) / 2;
      if (half * 2 >= 120) return;
      const ux = ax / (half * 2), uy = ay / (half * 2);
      const mx = pts[0] + ax / 2, my = pts[1] + ay / 2;
      const a0 = ink(T[0]), a1 = ink(T[T.length - 1]);
      for (let o = 0; o < w * h; o++) {
        if (time[o] !== -1 - i) continue;
        const X = (o % w) * S + S / 2 - mx, Y = ((o / w) | 0) * S + S / 2 - my;
        const rho = Math.hypot((X * ux + Y * uy) / (half + 20), (-X * uy + Y * ux) / 22);
        time[o] = a0 + (a1 - a0) * Math.min(1, Math.max(0, rho - 0.3) / 0.7);
      }
    });
    const dot0 = ink(DOT0);
    const rd = D.dot[2] + 10;
    const tx = (Math.ceil((D.dot[0] - rd) / S)), ty = (Math.ceil((D.dot[1] - rd) / S));
    for (let y = ty; y <= ty + 2 * rd / S; y++) {
      for (let x = tx; x <= tx + 2 * rd / S; x++) {
        const dd = Math.hypot(x * S + S / 2 - D.dot[0], y * S + S / 2 - D.dot[1]);
        if (dd < rd && x < w && y < h) time[y * w + x] = dot0 + (1 - dot0) * 0.75 * Math.max(0, dd - 0.35 * D.dot[2]) / (rd - 0.35 * D.dot[2]);
      }
    }
    await tick();
    return { w, h, S, time };
  };
  const write = (img, opts = {}) => {
    const done = () => {
      img.style.transition = 'none';
      img.classList.add('tpm-logo-in');
    };
    if (calm || !img.parentElement) return done();
    const go = () => {
      const src = img.currentSrc || img.src;
      const r = img.getBoundingClientRect();
      /* Image arrivée après le filet de sécurité CSS : déjà visible, on n'écrit pas. */
      if (!src || !r.width || getComputedStyle(img).opacity !== '0') return done();
      const pic = new Image();
      pic.crossOrigin = 'anonymous';
      pic.src = src;
      const dpr = Math.min(3, window.devicePixelRatio || 1);
      Promise.all([timeMap(), pic.decode()]).then(([m]) => build(pic, m, dpr)).catch(done);
    };
    /* Le logo est recopié dans un canvas à la résolution de l'écran ; chaque
       pixel reçoit son instant de passage (carte ci-dessus, interpolée) et son
       opacité suit la plume : 0 avant, montée continue sur SOFT derrière elle. */
    const build = (pic, m, dpr) => {
      const r = img.getBoundingClientRect();
      if (!r.width || getComputedStyle(img).opacity !== '0') return done();
      const W = Math.ceil(r.width * dpr), H = Math.ceil(r.height * dpr);
      const cv = document.createElement('canvas');
      cv.width = W;
      cv.height = H;
      cv.setAttribute('aria-hidden', 'true');
      cv.className = ('tpm-sign ' + (opts.className || '')).trim();
      const ctx = cv.getContext('2d', { willReadFrequently: true });
      /* Réduction par moitiés successives : aussi net que le logo affiché par le
         navigateur (une réduction d'un coup est plus floue, surtout sous Safari). */
      let src = pic, sw = pic.naturalWidth, sh = pic.naturalHeight;
      while (sw / 2 > r.width * dpr) {
        const t = document.createElement('canvas');
        t.width = Math.round(sw / 2);
        t.height = Math.round(sh / 2);
        const tc = t.getContext('2d');
        tc.imageSmoothingQuality = 'high';
        tc.drawImage(src, 0, 0, t.width, t.height);
        src = t;
        sw = t.width;
        sh = t.height;
      }
      ctx.imageSmoothingQuality = 'high';
      /* Taille exacte du logo (fractionnaire) dans une grille de pixels 1:1. */
      ctx.drawImage(src, 0, 0, r.width * dpr, r.height * dpr);
      const frameData = ctx.getImageData(0, 0, W, H);
      const px = frameData.data;
      ctx.clearRect(0, 0, W, H);
      let count = 0;
      for (let o = 3; o < px.length; o += 4) if (px[o]) count++;
      const list = new Uint32Array(count);
      const times = new Float32Array(count);
      const alpha = new Uint8Array(count);
      let c = 0;
      for (let y = 0; y < H; y++) {
        const my = Math.min(m.h - 1.001, Math.max(0, (y + 0.5) / (r.height * dpr) * 1070 / m.S - 0.5));
        const y0 = my | 0, fy = my - y0;
        for (let x = 0; x < W; x++) {
          const o = y * W + x;
          const a = px[o * 4 + 3];
          if (!a) continue;
          const mx = Math.min(m.w - 1.001, Math.max(0, (x + 0.5) / (r.width * dpr) * 2000 / m.S - 0.5));
          const x0 = mx | 0, fx = mx - x0;
          const k = y0 * m.w + x0;
          const a00 = m.time[k], a10 = m.time[k + 1], a01 = m.time[k + m.w], a11 = m.time[k + m.w + 1];
          times[c] = (a00 * (1 - fx) + a10 * fx) * (1 - fy) + (a01 * (1 - fx) + a11 * fx) * fy;
          list[c] = o;
          alpha[c] = a;
          c++;
          px[o * 4 + 3] = 0;
        }
      }
      const order = Uint32Array.from({ length: count }, (_, i) => i).sort((p, q) => times[p] - times[q]);
      const box = img.parentElement;
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      img.style.animation = 'none';
      box.append(cv);
      /* Position au sous-pixel près (offsetLeft arrondit) : le relais final est invisible. */
      const b = box.getBoundingClientRect();
      Object.assign(cv.style, { width: W / dpr + 'px', height: H / dpr + 'px', left: (r.left - b.left - box.clientLeft) + 'px', top: (r.top - b.top - box.clientTop) + 'px' });
      /* Pointe fondue : part du temps d'encre (≈ 1,2 % = 25 ms) sur laquelle un
         pixel passe de transparent à plein, juste derrière la plume. */
      const SOFT = opts.soft || 0.012;
      const DUR = opts.duration || 2000;
      const t0 = performance.now() + (opts.delay || 180);
      let lo = 0;
      const frame = (now) => {
        const u = Math.min(10000, Math.max(0, (now - t0) / DUR * 10000));
        const e = u <= 0 ? -1 : ink(u) * (1 + SOFT);
        for (let n = lo; n < order.length; n++) {
          const i = order[n];
          const t = times[i];
          if (t >= e) break;
          const f = Math.min(1, (e - t) / SOFT);
          px[list[i] * 4 + 3] = alpha[i] * f;
          if (f === 1 && n === lo) lo++;
        }
        ctx.putImageData(frameData, 0, 0);
        if (u < 10000) {
          requestAnimationFrame(frame);
        } else {
          /* Relais dans la même image : le canvas final et le logo sont identiques ;
             un fondu croisé ferait briller les bords (deux couches superposées). */
          done();
          cv.remove();
        }
      };
      frame(performance.now());
    };
    if (img.complete && img.naturalWidth) go();
    else img.addEventListener('load', go, { once: true });
  };
  const run = () => {
    if (root.classList.contains('tpm-intro')) {
      const logo = document.querySelector('.header-logo__image');
      if (logo) write(logo, { delay: 180, duration: 2000 });
    }
    document.querySelectorAll('img[data-tpm-write]').forEach((img) => {
      write(img, { delay: 450, duration: 2300, className: 'tpm-sign--hero' });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
